import React, { useMemo, useState } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { observer } from 'mobx-react';
import cm from 'classnames';
import { Button } from 'ksnm-common-ui/lib/Button';

import { designDrawerStore } from '@stores/designDrawerStore';

import styles from './DesignInnerForm.module.scss';

function DesignInnerFormComponent(): JSX.Element {
  const { form } = designDrawerStore;
  const { dirty, submitFailed, submitSucceeded, dirtySinceLastSubmit } = useFormState({
    subscription: {
      dirty: true,
      submitFailed: true,
      submitSucceeded: true,
      dirtySinceLastSubmit: true,
    },
  });
  const isDirty = (dirty && !submitFailed && !submitSucceeded) || dirtySinceLastSubmit;

  const [editMode, setEditMode] = useState(!!form?.editMode);

  const { submit } = useForm();

  const buttons = useMemo(
    () =>
      form?.buttons?.map((button) => (
        <Button
          size="large"
          key={button.key}
          type={button.type ?? 'default'}
          className={cm(styles.button, button.className)}
          onClick={() => {
            button.onClick?.();
            if (button.editButton) {
              setEditMode(() => true);
            }
            if (button.submitButton) {
              submit();
            }
          }}
          disabled={(!isDirty && button.submitButton) || (button.editButton && editMode)}
        >
          {button.label()}
        </Button>
      )),
    [editMode, form, isDirty, submit],
  );

  const formModel = useMemo(() => {
    if (form?.form) {
      if (typeof form.form === 'function') {
        return form.form(editMode);
      }
      return form.form;
    }
    return null;
  }, [editMode, form]);

  return (
    <div className={cm(styles.form, { [styles.withRequired]: form?.withRequired })}>
      {formModel} <div className={styles.buttons}>{buttons}</div>
      {form?.withRequired && (
        <div className={styles.required}>
          <p>*</p>
          <p>Обязательное поле для заполнения.</p>
        </div>
      )}
    </div>
  );
}

export const DesignInnerForm = observer(DesignInnerFormComponent);
